const stages = document.querySelectorAll<HTMLElement>('.event-stage');

stages.forEach((stage) => {
  const stickyBar = stage.querySelector<HTMLElement>(
    '.event-stage__sticky-bar',
  );
  const top = stage.querySelector<HTMLElement>('.event-stage__top');

  if (!stickyBar || !top) return;

  function setStickybarState() {
    if (!stickyBar || !top) return;

    if (window.scrollY > top.clientHeight) {
      stickyBar.dataset.show = '';
    } else {
      delete stickyBar.dataset.show;
    }
  }

  window.addEventListener('scroll', setStickybarState);
  setStickybarState();
});
